import UIComponent from "../../ui/component";

export class ResultTabsScroller extends UIComponent {
    #raf = 0;
    #peekVisiblePx = 24;

    init() {
        this.requireComponents({
            list: "document@.result-tabs__items",
            scrollLeft: "document@.result-tabs__scroll-btn--left",
            scrollRight: "document@.result-tabs__scroll-btn--right",
        });

        this.listEl = this.list.el();

        this.scrollLeft.on("click", () => this.scrollOne(-1));
        this.scrollRight.on("click", () => this.scrollOne(1));

        this.listEl.addEventListener("scroll", () => this.queueUpdate());
        window.addEventListener("resize", () => this.queueUpdate());

        this.queueUpdate();
    }

    #peekPx() {
        const raw = getComputedStyle(this.parent.element).getPropertyValue(
            "--result-tabs-fade-width"
        );
        const fadeWidth = parseFloat(raw) || 0;
        return Math.max(0, Math.round(fadeWidth + this.#peekVisiblePx));
    }

    #items() {
        return Array.from(this.listEl.querySelectorAll(".result-tabs__item"));
    }

    #left(node) {
        return node.offsetLeft || 0;
    }

    #right(node) {
        return (node.offsetLeft || 0) + (node.offsetWidth || 0);
    }

    scrollOne(direction) {
        const el = this.listEl;
        const items = this.#items();
        if (items.length === 0) return;

        const viewportLeft = el.scrollLeft;
        const viewportRight = viewportLeft + el.clientWidth;
        const peekPx = this.#peekPx();
        const maxScrollLeft = Math.max(0, el.scrollWidth - el.clientWidth);
        let target = null;

        if (direction > 0) {
            const next = items.find(
                (node) => this.#right(node) > viewportRight + 1
            );
            if (!next) return;
            target = this.#right(next) - (el.clientWidth - peekPx);
        } else {
            const prev = [...items]
                .reverse()
                .find((node) => this.#left(node) < viewportLeft - 1);
            if (!prev) return;
            target = this.#left(prev) - peekPx;
        }

        target = Math.min(maxScrollLeft, Math.max(0, target));
        el.scrollTo({ left: target, behavior: "smooth" });
        this.queueUpdate();
    }

    scrollActiveIntoView() {
        const active = this.list.getActiveItem();
        if (!active) return;
        active.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
        });
        this.queueUpdate();
    }

    queueUpdate() {
        if (this.#raf) return;
        this.#raf = requestAnimationFrame(() => {
            this.#raf = 0;
            this.update();
        });
    }

    update() {
        const el = this.listEl;
        const leftBtn = this.scrollLeft.el();
        const rightBtn = this.scrollRight.el();

        if (this.parent.element.classList.contains("d-none")) return;

        const clippedLeft = el.scrollLeft > 1;
        const clippedRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 1;

        leftBtn.classList.toggle("d-none", !clippedLeft);
        rightBtn.classList.toggle("d-none", !clippedRight);
        this.element.classList.toggle("result-tabs__desktop--fade-left", clippedLeft);
        this.element.classList.toggle(
            "result-tabs__desktop--fade-right",
            clippedRight
        );
    }
}
